export enum OverlayTypesEnum {
    TAKEOVER = 'Takeover',
    MODAL = 'Modal',
    GROWL = 'Growl'
}
export enum OverlayDisplayTypesEnum {
    E_CONSENT = 'electronicConsent',
    E_CONSENT_LEGAL = 'electronicConsentLegal'
}
